<template>
  <div class="baiduQueue">
    <div class="head">
      <img src="/static/index/index1.png" alt="">
      <div class="h0">
        <div class="h1">工程师e家</div>
        <div class="h2">
          <div class="h21"><el-input v-model="input" @keyup.enter.native="search" placeholder="输入品牌/型号"></el-input>
          </div>
          <div class="h22" @click="search1">查询</div>
        </div>
      </div>
    </div>
    <div class="label label2">
      <!-- <div class="l1">
        <div :class="item.typeId == typeId ? 'l11' : ''" v-for="(item, index) in treeList" :key="index"
          @click="updateTree(item)">{{ item.typeName }}</div>
      </div> -->
      <!-- <div class="l2" @click="updateState">
          <div>更多</div>
          <img src="/static/index/index3.png" alt="">
        </div> -->
    </div>
    <div class="box">
      <div class="b1">
        <!-- <div v-for="(item, index) in treeList_" :key="index">
          <div class="b11">{{ item.type }}</div>
          <div class="b12">
            <div v-for="(item2, index2) in item.children" :key="index2" @click="updateTreeChild(item2)"><img
                :src="item2.imageUrl" alt="">
              <div>{{ item2.typeName }}</div>
            </div>
          </div>
        </div> -->
        <!-- 小程序二维码提示 -->
        <div class="wx-qrcode-tip">
          <div class="tip-text">请扫码使用微信小程序</div>
          <img src="/static/wx.jpg" alt="小程序二维码" class="qrcode-img">
        </div>
      </div>

    </div>
    <el-dialog :title="videoTitle" :visible.sync="dialogVisible" width="50%" :before-close="no">
      <video autoplay controls style="width:100%;height:400px;" :src="src"></video>
    </el-dialog>
    <footer1></footer1>
    <show ref="show"></show>
  </div>
</template>

<script>
import Cookie from "js-cookie";

export default {
  title: "课程列表",
  data() {
    return {
      pdfImg: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fwww.likeyunba.com%2Fpan%2Fres%2F1500320053.jpg&refer=http%3A%2F%2Fwww.likeyunba.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1611302694&t=2ff816eeb00c5f01c1b0f136aecf2e28',
      wordImg: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fku.90sjimg.com%2Felement_pic%2F18%2F07%2F12%2F99d868145755a82fc42f856f0a7968c3.jpg&refer=http%3A%2F%2Fku.90sjimg.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1611302692&t=0c3c3c3b4db9e18d716d3ac3cfb1f7e3',
      imageImg: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fbpic.588ku.com%2Felement_origin_min_pic%2F00%2F97%2F07%2F3156f313952d39b.jpg&refer=http%3A%2F%2Fbpic.588ku.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1611375698&t=3a4d1c41c976e8f24ad887af91ac8cd9',
      input: '', // 搜索产品输入
      state: false,// 是否显示所有产品类型
      instructions: false,//是否显示某个产品型号说明书
      modelIndex: 0,//产品型号 经销商 应用视频 故障视频 公司介绍切换
      typeId: 0,
      treeList: [],
      treeList_: [],
      list: [],
      list2: [],
      list3: [],
      agent: [],
      specList: [],
      dialogVisible: false,
      dialogVisible2: false,
      videoTitle: '',
      src: '',
      price: ''

    };
  },
  computed: {},
  components: {},
  mounted() {
    // this.$axios
    //   .post("/do_search_ware", this.$qs.stringify({ parent: 1 }))
    //   .then((res) => {
    //     console.log(res);
    //     this.treeList = res.data.data
    //     this.typeId = res.data.data[0].typeId
    //     this.getData(res.data.data[0].typeId)

    //   });
    this.$axios
      .post('/do_get_setting').then(res => {
        for (let i = 0; i < res.data.data.length; i++) {
          if (res.data.data[i].itemKey == 'download') {
            this.price = res.data.data[i].settingValue
          }
        }

      });

    if (Cookie.get('id')) {
      let params = {
        aid: Cookie.get('id'),
        type: 'PC'
      };

      this.$axios
        .post('https://www.gcsej.cn/gcsej/app/do_online_count', this.$qs.stringify(params)).then(res => {
          console.log(res)
        })

    }
  },
  methods: {
    search() {
      if (!this.input) {
        this.$message.error("请输入搜索内容");
        return;
      }
      this.$router.push({
        path: '/search',
        query: {
          item: this.input
        }
      })
    },
    no() {
      this.dialogVisible = false
      this.dialogVisible2 = false
      this.src = ''
    },
    view(e, index) {

      if (!Cookie.get('id')) {
        this.$message.error("请登录");
        return;
      }

      if (index == 2) {

        let params = {
          aid: Cookie.get('id'),
          access_token: sessionStorage.getItem('access_token')
        };
        this.$axios.post('/get_account_info', this.$qs.stringify(params)).then(res => {
          if (res.data.errCode == 0) {
            // console.log(res.data.data)
            if (res.data.data.integral < Number(this.price)) {
              // this.$message.error(`下载当前文件需要花费${Number(this.price)}积分,你的积分不足，请充值`);
              this.$refs.show.click()
              return;
            } else {
              this.$confirm(`下载当前文件需要花费${Number(this.price)}积分，你当前积分为${res.data.data.integral}。获取积分方式：1. 签到获取积分 2.小程序转发群和朋友圈获取积分`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              })
                .then(() => {
                  this.$axios.post(`/download_file`, this.$qs.stringify({ aid: Cookie.get('id') })).then(res => {
                    if (res.data.errCode == 0) {
                      // this.$router.push({
                      //   path:'/view',
                      //   query:{
                      //     url:e.materials[0].imageUrl,
                      //     index
                      //   }
                      // })
                      window.open(e.materials[0].imageUrl)
                    }
                  })
                })
                .catch(() => { });
            }
          }
        })

      } else {
        if (e.fileType == 'pdf') {
          this.$router.push({
            path: '/view',
            query: {
              url: e.materials[0].imageUrl,
              index
            }
          })
        } else if (e.fileType == 'doc') {
          window.open(
            "https://view.officeapps.live.com/op/view.aspx?src=" + e.materials[0].imageUrl,
            "_blank"
          );
        } else if (e.fileType == 'png' || e.fileType == 'jpg') {
          this.$router.push({
            path: '/pngView',
            query: {
              url: e.materials[0].imageUrl,
              index
            }
          })
        }

      }


      // window.open(e.materials[0].imageUrl, "_blank");
    },
    video(e) {
      if (!Cookie.get('id')) {
        this.$message.error("请登录");
        return;
      }
      let params = {
        aid: Cookie.get('id'),
        wareId: e.wareId
      };
      this.$axios.post('/do_check_video', this.$qs.stringify(params)).then(res => {
        if (res.data.data.recordId > 0) {
          this.dialogVisible = true
          this.videoTitle = e.wareName
          this.src = e.specList[0].materials[0].imageUrl
        } else {
          this.$message.error("您没有此权限，请下载app或打开微信小程序购买视频或会员");
          return;
        }
      })

    },
    chooseSpec(e) {
      this.specList = e.specList
      for (let i = 0; i < this.specList.length; i++) {
        this.specList[i].fileType = this.specList[i].materials[0].imageUrl.split('.')[this.specList[i].fileType = this.specList[i].materials[0].imageUrl.split('.').length - 1]
      }
      this.instructions = true
    },
    //  产品型号 经销商 应用视频 故障视频 公司介绍切换
    updateTree(e) {
      this.typeId = e.typeId
      this.getData(e.typeId)
    },
    updateTreeChild(e) {
      this.$router.push({
        path: '/brand',
        query: {
          id: e.typeId
        }
      })
    },
    updateModerIndex(e) {
      this.modelIndex = e
      this.instructions = false
    },
    // 是否显示所有产品类型
    updateState() {
      this.state = !this.state
    },
    getData(e) {
      // this.$axios
      //   .post("/do_search_ware", this.$qs.stringify({ keyword: this.input == '' ? null : this.input, typeId: e }))
      //   .then((res) => {
      //     console.log(res);
      //     this.treeList_ = res.data.data
      //   });

    },
  },
};
</script>
<style lang="scss" scoped>
.baiduQueue {
  width: 100%;
  height: 100%;
  overflow-y: auto;

  // min-height: 940px;
  // display: flex;
  // flex-direction: column;
  .head {
    width: 100%;
    height: 470px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
    }

    .h0 {
      width: 1200px;
      z-index: 1;

      .h1 {
        font-size: 46px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #FFFFFF;
        margin-bottom: 58px;
        text-align: center;
      }

      .h2 {
        width: 922px;
        height: 78px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #FFFFFF;
        border-radius: 6px;
        margin: 0 auto;

        .h21 {
          padding-left: 30px;
          width: 80%;

          .el-input {
            width: 80%;
          }

          /deep/ .el-input__inner {
            border: none;

            font-size: 24px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #999999;
          }
        }

        .h22 {
          width: 208px;
          height: 78px;
          background: #FF5602;
          border-radius: 6px;
          text-align: center;
          line-height: 78px;
          font-size: 24px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          color: #FFFFFF;
        }
      }
    }
  }

  .label {
    width: 1200px;
    margin: 50px auto 30px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    height: 50px;
    overflow: hidden;
    transition: height 1s;

    .l1 {
      display: flex;
      flex-wrap: wrap;

      width: 100%;

      div {
        padding: 0 26px;
        height: 50px;
        background: #FFFFFF;
        border-radius: 33px;
        line-height: 50px;
        font-size: 20px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
        margin-right: 10px;
        margin-bottom: 10px;
        cursor: pointer;
      }

      .l11 {
        background: #198AFA;
        color: #FFFFFF;
      }
    }

    .l2 {
      display: flex;
      align-items: center;
      height: 50px;
      cursor: pointer;

      div {
        font-size: 20px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
        margin-right: 6px;
      }

      img {
        width: 12px;
        height: 8px;
      }
    }
  }

  .label2 {
    height: auto;
    transition: height 1s;
  }

  .box {
    width: 1200px;

    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .b1 {
      width: 100%;
      // padding: 0 11px;

      background: #FFFFFF;
      padding-top: 10px;
      padding-bottom: 30px;
      min-height: 940px;

      /**
       * 小程序二维码提示区域样式
       */
      .wx-qrcode-tip {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 60px 20px;
        text-align: center;

        .tip-text {
          font-size: 28px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #333333;
          margin-bottom: 30px;
        }

        .qrcode-img {
          width: 300px;
          height: 300px;
          border-radius: 8px;
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
        }
      }

      .b11 {
        height: 57px;
        line-height: 57px;
        text-align: center;
        font-size: 24px;
        font-family: Arial-BoldMT, Arial;
        background: #E4F0FC;
        font-weight: normal;
        color: #198AFA;
        border-bottom: 1px solid #9797971f;
        margin-bottom: 30px;
      }

      .b12 {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        padding: 0 20px;

        &>div {
          width: 100px;
          height: 120px;
          background: #FFFFFF;

          border-radius: 6px;
          margin-right: 17px;
          margin-bottom: 20px;

          img {
            width: 100%;
            height: 100px;
            box-shadow: 0px 0px 4px 0px #198AFA;
          }

          div {
            text-align: center;
            font-size: 20px;
            font-family: SourceHanSansCN-Normal, SourceHanSansCN;
            font-weight: 400;
            color: #333333;
          }

        }

        &>div:nth-child(10n) {
          margin-right: 0;
        }

      }
    }

  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/index.vue